import { Injectable } from '@angular/core';
import { UserService } from '~services/user.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BonusEnabledRouteGuard {
  constructor(public userService: UserService, private router: Router) {}

  canActivate(): boolean {
    if (this.userService.bonusEventEnabled()) {
      return true;
    }

    if (this.userService.isLMOAccount()) {
      this.router.navigate(['/', 'lmo', 'frac', 'list']);
    }

    return false;
  }
}
